import React from 'react';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import GetRelatedServicesQuery, {
  GetRelatedServicesQueryData,
} from './graphql/GetRelatedServicesQuery.graphql';
import {getServicesMarketplacePublicClient} from 'utilities/graphql/client';
import {notifyException} from 'utilities/analytics/bugsnag';
import {RelatedServices, SkeletonRelatedServices} from '../related-services';
import {serviceListingsToServiceDimensionsMap} from 'sections/services-marketplace/experts/utilities';

const client = getServicesMarketplacePublicClient();

interface OwnProps {
  expertHandle: string;
  profileHandle: string;
  serviceHandle: string;
}

interface State {
  profile?: GetRelatedServicesQueryData.Profile;
  error?: any;
}

type CombinedProps = OwnProps & WithI18nProps;

class RelatedServicesContainer extends React.Component<CombinedProps, State> {
  state: State = {
    profile: undefined,
    error: undefined,
  };

  componentDidMount() {
    client
      .query<{
        profile: GetRelatedServicesQueryData.Profile;
      }>({
        query: GetRelatedServicesQuery,
        variables: {
          handle: this.props.profileHandle,
        },
      })
      .then(res => {
        this.setState({profile: res.data.profile});
      })
      .catch(error => {
        notifyException({error});
        this.setState({error});
      });
  }

  render() {
    const {profile, error} = this.state;
    const {expertHandle, serviceHandle} = this.props;

    if (profile) {
      const serviceDimensionsMap = serviceListingsToServiceDimensionsMap(
        profile.serviceListings
      );
      return (
        <RelatedServices
          expertHandle={expertHandle}
          serviceHandle={serviceHandle}
          serviceListings={profile.serviceListings}
          serviceDimensionsMap={serviceDimensionsMap}
          businessName={profile.businessName}
        />
      );
    } else if (error) {
      return (
        <ErrorCard message={'We cannot load related services right now.'} />
      );
    } else {
      return <SkeletonRelatedServices />;
    }
  }
}

interface ErrorCardProps {
  message: string;
}

function ErrorCard({message}: ErrorCardProps) {
  return <p>{message}</p>;
}

export default withI18n()(RelatedServicesContainer);
